<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <v-row>
          <v-col>
            Zdravotní rizika v zaměstnání (chemikálie, radiace)
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              mode="lazy"
              rules="required"
              v-model="form.healthRisksAtWork.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.healthRisksAtWork.status == '1' ? 'required' : ''"
              v-model="form.healthRisksAtWork.value"
              label="Jaká?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.healthRisksAtWork.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Prodělané choroby v dětství
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              mode="lazy"
              rules="required"
              v-model="form.childDiseases.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Běžné"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Jiné"
                       value="1" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.childDiseases.status == '1' ? 'required' : ''"
              v-model="form.childDiseases.value"
              label="Jaké?"
              rows="2"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.childDiseases.status !== '1'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Operace
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              mode="lazy"
              rules="required"
              v-model="form.operation.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.operation.status == '2' ? 'required' : ''"
              v-model="form.operation.value"
              label="Jaké a v jakém věku?"
              rows="2"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.operation.status != '2'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Sledování u odborných lékařů
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              mode="lazy"
              rules="required"
              v-model="form.monitoring.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.monitoring.status == '2' ? 'required' : ''"
              v-model="form.monitoring.value"
              label="U kterých?"
              rows="2"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.monitoring.status != '2'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Trvale užívané léky
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              mode="lazy"
              rules="required"
              v-model="form.permanentDrugs.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.permanentDrugs.status == '2' ? 'required' : ''"
              v-model="form.permanentDrugs.value"
              label="Jaké?"
              rows="2"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.permanentDrugs.status != '2'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Alergie vč. lékové alergie
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              mode="lazy"
              rules="required"
              v-model="form.alergyIncludingDrugsAlergy.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       :value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextAreaWithValidation
              :rules="form.alergyIncludingDrugsAlergy.status == '2' ? 'required' : ''"
              v-model="form.alergyIncludingDrugsAlergy.value"
              label="Jaké?"
              rows="2"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.alergyIncludingDrugsAlergy.status != '2'"
              outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Byla u Vás zjištěna zvýšená hladina cholesterolu?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.cholesterol.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.cholesterol.status == '1' ? 'required' : ''"
              v-model="form.cholesterol.value"
              label="Hodnota"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.cholesterol.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Byla u Vás zjištěna zvýšená hladina glykémie?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.glycemia.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nevím"
                       value="3" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.glycemia.status == '1' ? 'required' : ''"
              v-model="form.glycemia.value"
              label="Hodnota"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.glycemia.status !== '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Kouříte cigarety?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.cigarettes.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.cigarettes.status == '1' ? 'required' : ''"
              v-model="form.cigarettes.value"
              label="Kolik cigaret za den?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.cigarettes.status != '1'" />
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.cigarettes.status == '1' ? 'required' : ''"
              v-model="form.cigarettes.value2"
              label="Jak dlouho?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.cigarettes.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Kouříte e-cigarety?
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.electronicCigarettes.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.electronicCigarettes.status == '1' ? 'required' : ''"
              v-model="form.electronicCigarettes.value"
              label="Kolik cigaret za den?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.electronicCigarettes.status != '1'" />
          </v-col>
          <v-col cols="auto">
            <VTextFieldWithValidation
              :rules="form.electronicCigarettes.status == '1' ? 'required' : ''"
              v-model="form.electronicCigarettes.value2"
              label="Jak dlouho?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.electronicCigarettes.status != '1'" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            class="pb-0">
            Konzumace alkoholu
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.alcohol.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="pb-0"
            cols="12">
            Pivo
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              :disabled="form.alcohol.status != 1"
              :rules="form.alcohol.status == 1 ? 'required' : ''"
              v-model="form.alcohol.statusBeer"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.alcohol.statusBeer == '1' && form.alcohol.status == 1 ? 'required' : ''"
              v-model="form.alcohol.valueBeer"
              label="Jaké množství týdně?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.alcohol.statusBeer != '1' || form.alcohol.status != 1" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="pb-0"
            cols="12">
            Víno
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              :disabled="form.alcohol.status != 1"
              :rules="form.alcohol.status == 1 ? 'required' : ''"
              v-model="form.alcohol.statusWine"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.alcohol.statusWine == '1' && form.alcohol.status == 1 ? 'required' : ''"
              v-model="form.alcohol.valueWine"
              label="Jaké množství týdně?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.alcohol.statusWine != '1' || form.alcohol.status != 1" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="pb-0"
            cols="12">
            Destiláty
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              :disabled="form.alcohol.status != 1"
              :rules="form.alcohol.status == 1 ? 'required' : ''"
              v-model="form.alcohol.statusSpirit"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="2" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.alcohol.statusSpirit == '1' && form.alcohol.status == 1 ? 'required' : ''"
              v-model="form.alcohol.valueSpirit"
              label="Jaké množství týdně?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.alcohol.statusSpirit != '1' || form.alcohol.status != 1" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12">
            Jiné návykové látky
          </v-col>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="form.addictiveSubstances.status"
              row
              custom-class="mt-0 pt-0">
              <v-radio color="blue lighten-1"
                       label="Ano"
                       value="1" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       value="2" />
              <v-radio color="blue lighten-1"
                       label="Nechci uvést"
                       value="4" />
            </VRadioWithValidation>
          </v-col>
          <v-col>
            <VTextFieldWithValidation
              :rules="form.addictiveSubstances.status == '1' && form.alcohol.status != 1 ? 'required' : ''"
              v-model="form.addictiveSubstances.value"
              label="Jaké?"
              mode="lazy"
              custom-class="mt-0 pt-0"
              :disabled="form.addictiveSubstances.status != '1'" />
          </v-col>
          <v-col
            cols="auto">
            <v-btn @click="submit()"
                   type="submit"
                   x-large
                   depressed
                   height="68px"
                   class="px-12 white--text"
                   color="blue lighten-1">
              Uložit
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<style>
@import url('https://fonts.googleapis.com/css?family=Material+Icons');
</style>

<script>
export default {
  name: 'ThePersonalAnamnesis',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: {
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        healthRisksAtWork: {
          status: 0,
          value: ''
        },
        childDiseases: {
          status: 0,
          value: ''
        },
        operation: {
          status: 0,
          value: ''
        },
        monitoring: {
          status: 0,
          value: ''
        },
        permanentDrugs: {
          status: 0,
          value: ''
        },
        alergyIncludingDrugsAlergy: {
          status: 0,
          value: ''
        },
        cholesterol: {
          status: 0,
          value: ''
        },
        glycemia: {
          status: 0,
          value: ''
        },
        cigarettes: {
          status: 0,
          value: '',
          value2: '',
        },
        electronicCigarettes: {
          status: 0,
          value: '',
          value2: '',
        },
        alcohol: {
          status: 0,
          value: ''
        },
        addictiveSubstances: {
          status: 0,
          value: ''
        }
      }
    };
  },
  computed: {
    formtosend() {
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        healthRisksAtWork: {
          status: this.form.healthRisksAtWork.status,
          value: this.form.healthRisksAtWork.value
        },
        childDiseases: {
          status: Number(this.form.childDiseases.status),
          value: this.form.childDiseases.value
        },
        operation: {
          status: this.form.operation.status,
          value: this.form.operation.value
        },
        monitoring: {
          status: this.form.monitoring.status,
          value: this.form.monitoring.value
        },
        permanentDrugs: {
          status: this.form.permanentDrugs.status,
          value: this.form.permanentDrugs.value
        },
        alergyIncludingDrugsAlergy: {
          status: this.form.alergyIncludingDrugsAlergy.status,
          value: this.form.alergyIncludingDrugsAlergy.value
        },
        cholesterol: {
          status: Number(this.form.cholesterol.status),
          value: this.form.cholesterol.value
        },
        glycemia: {
          status: Number(this.form.glycemia.status),
          value: this.form.glycemia.value
        },
        cigarettes: {
          status: Number(this.form.cigarettes.status),
          value: `${this.form.cigarettes.value}, ${this.form.cigarettes.value2}`
        },
        electronicCigarettes: {
          status: Number(this.form.electronicCigarettes.status),
          value: `${this.form.electronicCigarettes.value}, ${this.form.electronicCigarettes.value2}`
        },
        alcohol: {
          status: Number(this.form.alcohol.status),
          value: JSON.stringify({
            alcoholValue: this.form.alcohol.value,
            statusBeer: this.form.alcohol.statusBeer,
            valueBeer: this.form.alcohol.valueBeer,
            statusWine: this.form.alcohol.statusWine,
            valueWine: this.form.alcohol.valueWine,
            statusSpirit: this.form.alcohol.statusSpirit,
            valueSpirit: this.form.alcohol.valueSpirit,
          })
        },
        addictiveSubstances: {
          status: Number(this.form.addictiveSubstances.status),
          value: this.form.addictiveSubstances.value
        }
      });
    }
  },
  methods: {
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formtosend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/personalanamnesis', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/personalanamnesis', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.form = {
        healthRisksAtWork: {
          status: data.healthRisksAtWork.status,
          value: data.healthRisksAtWork.value
        },
        childDiseases: {
          status: String(data.childDiseases.status),
          value: data.childDiseases.value
        },
        operation: {
          status: data.operation.status,
          value: data.operation.value
        },
        monitoring: {
          status: data.monitoring.status,
          value: data.monitoring.value
        },
        permanentDrugs: {
          status: data.permanentDrugs.status,
          value: data.permanentDrugs.value
        },
        alergyIncludingDrugsAlergy: {
          status: data.alergyIncludingDrugsAlergy.status,
          value: data.alergyIncludingDrugsAlergy.value
        },
        cholesterol: {
          status: String(data.cholesterol.status),
          value: data.cholesterol.value
        },
        glycemia: {
          status: String(data.glycemia.status),
          value: data.glycemia.value
        },
        cigarettes: {
          status: String(data.cigarettes.status),
          value: data.cigarettes.value.split(',', 2)[0],
          value2: data.cigarettes.value.split(',', 2)[1],
        },
        electronicCigarettes: {
          status: String(data.electronicCigarettes.status),
          value: data.electronicCigarettes.value.split(',', 2)[0],
          value2: data.electronicCigarettes.value.split(',', 2)[1],
        },
        alcohol: {
          status: String(data.alcohol.status),
          value: JSON.parse(data.alcohol.value).alcoholValue,
          alcoholValue: JSON.parse(data.alcohol.value).alcoholValue,
          statusBeer: JSON.parse(data.alcohol.value).statusBeer,
          valueBeer: JSON.parse(data.alcohol.value).valueBeer,
          statusWine: JSON.parse(data.alcohol.value).statusWine,
          valueWine: JSON.parse(data.alcohol.value).valueWine,
          statusSpirit: JSON.parse(data.alcohol.value).statusSpirit,
          valueSpirit: JSON.parse(data.alcohol.value).valueSpirit,
        },
        addictiveSubstances: {
          status: String(data.addictiveSubstances.status),
          value: data.addictiveSubstances.value
        }
      };
    });
  }
};
</script>
